import { SxObjType } from "lib/theme/types/SxObjType.type";

const sxStyles = () => {
  return {
    layout: {},
  } satisfies SxObjType;
};

export { sxStyles };
